<template>
  <VForms
    :initial-values="form"
    :validation-schema="validations"
    @submit="handleSubmit"
  >
    <template slot-scope="props">
      <form
        class="login-form"
        @submit.prevent="props.handleSubmit"
      >
        <VTextField
          v-model="props.values.email"
          :error-messages="getEmailErrors(props.errors.email)"
          label="E-mail"
        />
        <VTextField
          v-model="props.values.password"
          :error-messages="getPasswordErrors(props.errors.password)"
          :label="$t('login.password')"
          type="password"
        />
        <div class="links">
          <router-link to="/register">
            {{ $t('login.registerLink') }}
          </router-link>
          <router-link to="/resetPassword">
            {{ $t('login.resetPasswordLink') }}
          </router-link>
        </div>
        <VBtn
          color="primary"
          :loading="props.isSubmitting"
          type="submit"
        >
          {{ $t('login.login') }}
        </VBtn>
      </form>
    </template>
  </VForms>
</template>

<script>
import { Form as VForms } from '@v-forms/core'
import { mapActions } from 'vuex'
import {
  required,
  email,
} from 'vuelidate/lib/validators'
import { ACTION_LOGIN } from '../store/types/user.types'

export default {
  name: 'LoginForm',
  components: {
    VForms,
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      validations: {
        email: {
          required,
          email,
        },
        password: { required },
      },
    }
  },
  methods: {
    async handleSubmit(values, actions) {
      await this.login(values)
      actions.setSubmitting(false)
    },
    getEmailErrors(values = {}) {
      const errors = []
      if (values.required) errors.push(this.$t('validates.requiredField'))
      if (values.email) errors.push(this.$t('validates.emailNotValid'))
      return errors
    },
    getPasswordErrors(values = {}) {
      const errors = []
      if (values.required) errors.push(this.$t('validates.requiredField'))
      return errors
    },
    ...mapActions({
      login: ACTION_LOGIN,
    }),
  },
}
</script>

<style lang="stylus" scoped>
.links {
  display: flex;
  flex-direction: column;
  margin: 1em 0;
  a {
    color: var(--v-secondary-base)
  }
}

.login-form {
  max-width: 30em;
}

@media only screen and (max-width: 480px) {
  .login-form {
    padding: 0 2em;
  }
}
</style>
